import type { ReactNode } from 'react'

export function LoginShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-2">
            <img src="/TrueMark logo.svg" alt="TrueMark" className="h-12" />
            <span className="text-3xl font-bold text-gray-900">TrueMark</span>
          </div>
          <p className="text-gray-500">Система маркировки товаров</p>
        </div>
        <div className="rounded-2xl bg-white p-6 shadow-lg sm:p-8">{children}</div>
      </div>
    </div>
  )
}
